<form class="form" [formGroup]="dontSeeYourWorkplaceFormGroup">

  <div *ngIf="showEnterWorkplaceFormManuallySection">
    <div class="row">
      <div class="col-md-12">
        <div class="dontseeyour-workplace">
          <h2><strong>{{cfetLabels.cfet_customer_eligibility.dont_see_your_workplace_desc}}</strong></h2>
        </div>
      </div>
    </div>

    <div class="row form-row" id="name-input" [class.error]="!isValidName">
      <div class="col-md-12">
        <label for="name">{{cfetLabels.cfet_customer_eligibility.name}}</label>
        <div class="name-inputbox">
          <input id="name" class="name" name="name" tabindex="0" formControlName="nameValue" maxlength="256" type="text"
            restrict-input="restrictforOrgName" autocomplete="off" aria-label="First name" (blur)="checkName()">
          <div *ngIf="!isValidName" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (!isValidName)}">
            <em class="icon-badgealert" aria-hidden="true"></em>
            <span *ngIf="!isValidName">{{cfetMessages.first_name_error}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-row" id="address1-input" [class.error]="isValidAddress1">
      <div class="col-md-12">
        <label for="address1">{{cfetLabels.cfet_customer_eligibility.address}}
          <span id="line1-desc"> {{cfetLabels.cfet_customer_eligibility.line1}}</span></label>
        <div class="address1-inputbox">
          <input id="address1" class="address1" name="address1" tabindex="0" formControlName="address1Value"
            maxlength="256" type="text" autocomplete="off" aria-label="Address line 1" (blur)="checkAddress1()">
          <div *ngIf="isValidAddress1" role="alert" [attr.aria-atomic]="true"
            [ngClass]="{'error-msg' : isValidAddress1}">
            <em class="icon-badgealert" aria-hidden="true"></em>
            <span *ngIf="isValidAddress1">{{cfetMessages.address_line}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="address2-input">
      <div class="col-md-12">
        <label for="address2" id="address2-label">{{cfetLabels.cfet_customer_eligibility.address}}</label>
        <span id="line2-desc"> {{cfetLabels.cfet_customer_eligibility.line2}}</span>
        <label for="optional" id="optional">{{cfetLabels.cfet_customer_eligibility.optional}}</label>
        <div class="address2-inputbox">
          <input id="address2" class="address2" name="address2" tabindex="0" formControlName="address2Value"
            maxlength="256" type="text" autocomplete="off" aria-label="Address line 2">
        </div>
      </div>
    </div>

    <div class="row form-row" id="city-input" [class.error]="cityError">
      <div class="col-md-12">
        <label for="city">{{cfetLabels.cfet_customer_eligibility.city}}</label>
        <div class="city-inputbox">
          <input id="city" class="city" name="city" tabindex="0" formControlName="cityValue" maxlength="40" type="text"
            restrict-input="restrictforModalCity" aria-label="City" (blur)="checkCity()">
          <div *ngIf="cityError" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (cityError)}">
            <em class="icon-badgealert" aria-hidden="true"></em>
            <span *ngIf="cityError">{{cfetMessages.city}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="row-dropdown">
      <div class="col-md-12" id="state-section">
        <label for="select_state">{{cfetLabels.cfet_customer_eligibility.state}}</label>
        <div class="field-group">
          <div [ngClass]="checkState ? 'dropdown-opened' : ''">
            <abs-dropdown [drId]="'select_state'" [drName]="'stateValue'" [(dropdownValue)]="stateValueOption"
              [optionRepeat]="stateList" formControlName="stateValue"
              (dropdownValueChange)="onChangeStateOption($event)" (click)="onClickState($event)"
              ngDefaultControl>
            </abs-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-row" id="zipcode-input" [class.error]="zipcodeError">
      <div class="col-md-12">
        <label for="zipcode">{{cfetLabels.cfet_customer_eligibility.zipcode_manually}}</label>
        <div class="zipcode-inputbox">
          <input id="zipcode" class="zipcode" name="zipcode" tabindex="0" formControlName="zipCode" maxlength="10"
            type="text" restrict-input="restrictzipcode" aria-label="Zipcode" (input)="changeZip()" (blur)="checkZip()">
          <div *ngIf="zipcodeError" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (zipcodeError)}">
            <em class="icon-badgealert" aria-hidden="true"></em>
            <span *ngIf="zipcodeError">{{cfetMessages.valid_zipcode}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="dontSeeWorkplace-footer-column1">
      <div class="col-md-12">
        <button type="button" id="btn-submit" (click)="submit($event)" (keyup)="submit($event)"
          class="btn btn-alt btn-medium" tabindex="0" [disabled]="disabledSubmitButton">
          {{cfetButtonLabels.button_labels.submit}}</button>
      </div>
    </div>
    <div class="row" id="dontSeeWorkplace-footer-column2">
      <div class="col-md-12">
        <a data-dismiss="modal" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)" tabindex="0"
          type="button" id="cancel_link" class="btn btn-secondary btn-clear cancel_link">
          {{cfetButtonLabels.button_labels.cancel}}</a>
      </div>
    </div>

  </div>

  <div class="row" id="eligibility-completion-section" *ngIf="showEligibilityCompletion">

    <div class="col-md-10 eligibility-mobile-max">
      <div class="selected-workplace">
        <label for="selected-workplace-address"
          class="selected-workplace-address"><strong>{{selectedName}}</strong></label><br>
        <label for="selected-workplace-city-state-zipcode"
          class="selected-workplace-city-state-zipcode">{{this.selectedAddress1}}, {{selectedCity}},
          {{selectedState}} {{selectedZip}}</label>
      </div>
    </div>

    <div class="col-md-12" id="eligibility-completion">
      <app-customer-eligibility-completion></app-customer-eligibility-completion>
    </div>

  </div>

</form>